import React from 'react';

import { Icon } from '@chakra-ui/react';
import {
  MdBarChart,
  MdPerson,
  MdHome,
} from 'react-icons/md';
import { FaUserDoctor } from "react-icons/fa6";
import { GrUserAdmin } from "react-icons/gr";
import { AiOutlineIssuesClose, AiOutlineProduct, AiOutlineStock } from "react-icons/ai";
import { BiTransferAlt, BiPurchaseTagAlt, BiGroup } from "react-icons/bi";
import { PiKeyReturn } from "react-icons/pi";
import { TbInvoice, TbUserCheck } from "react-icons/tb";
import { LuSquareDashedBottomCode } from "react-icons/lu";
import { LiaFileInvoiceSolid, LiaSortAmountUpSolid, LiaSortAmountDownSolid } from "react-icons/lia";
import { HiOutlineReceiptTax } from "react-icons/hi";
import { CgCalendarDates } from "react-icons/cg";

// Admin Imports
import SignIn from 'views/auth/signIn';
import MasterDashboard from 'views/master/default'
import AdminUser from 'views/master/adminUser/Index';
import SalesReport from 'views/master/salesReport/Index';
import AccountMaster from 'views/master/accountMaster/AccountMaster';
import BatchMaster from 'views/master/batchMaster/BatchMaster';
import ProductMaster from 'views/master/productMaster/ProductMaster';
import DoctorMaster from 'views/master/doctorMaster/DoctorMaster';
import PatientMaster from 'views/master/patientMaster/PatientMaster';
import HsnMaster from 'views/master/hsnMaster/HsnMaster';
import PurchaseBill from 'views/master/purchaseBill/PurchaseBill';
import SalesInvoice from 'views/master/salesInvoice/SalesInvoice';
import PurchaseReturn from 'views/master/purchaseReturn/PurchaseReturn';
import PurchaseReport from 'views/master/purchaseReport/PurchaseReport';
import StockReport from 'views/master/stockReport/StockReport';
import AboutData from 'views/master/about/AboutData';
import LowReport from 'views/master/lowReport/LowReport';
import ProductReport from 'views/master/productReport/ProductReport';
import GstProductReport from 'views/master/productReport/GstProductReport';
import ExpDateReport from 'views/master/expdateReport/ExpDateReport';
import MedicinePurchaseReport from 'views/master/PartyReport/MedicinePurchaseReport';
import ProductBatchReport from 'views/master/productBatchReport/productBatchReport';



const role = localStorage.getItem('role');

const isAuthenticated = localStorage.getItem('isAuthenticated')

let routes = []

if (!isAuthenticated) {
  routes.push(
    {
      name: 'Sign In',
      layout: '/auth',
      path: '/sign-in',
      icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
      component: <SignIn />,
    }
  );
}

// routes.push(


// )
if (role == "Super Admin") {
  routes.push(
    {
      name: 'Master Dashboard',
      layout: '/master',
      path: '/MasterDashboard',
      icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
      component: <MasterDashboard />,
    },
    {
      name: 'Master',
      layout: '/master',
      icon: <Icon as={MdBarChart} width="20px" height="20px" color="inherit" />,
      path: '/AccountMaster',
      component: <AccountMaster />,
      children: [
        {
          name: 'Account Master',
          layout: '/master',
          icon: <Icon as={AiOutlineIssuesClose} width="20px" height="20px" color="inherit" />,
          path: '/AccountMaster',
          component: <AccountMaster />,
        },
        {
          name: 'Batch Master',
          layout: '/master',
          path: '/BatchMaster',
          icon: <BiGroup width="20px" height="20px" color="inherit" className='text-lg' />,
          component: <BatchMaster />,
        },
        {
          name: 'Product Master',
          layout: '/master',
          path: '/ProductMaster',
          icon: <AiOutlineProduct width="20px" height="20px" color="inherit" className='text-lg' />,
          component: <ProductMaster />,
        },
        {
          name: 'Doctor Master',
          layout: '/master',
          path: '/DoctorMaster',
          icon: <FaUserDoctor width="20px" height="20px" color="inherit" />,
          component: <DoctorMaster />,
        },
        {
          name: 'Patient Master',
          layout: '/master',
          path: '/PatientMaster',
          icon: <TbUserCheck width="20px" height="20px" color="inherit" className='text-lg' />,
          component: <PatientMaster />,
        },
        {
          name: 'HSN Master',
          layout: '/master',
          path: '/HsnMaster',
          icon: <LuSquareDashedBottomCode width="20px" height="20px" color="inherit" className='text-lg' />,
          component: <HsnMaster />,
        },
        {
          name: 'About',
          layout: '/master',
          path: '/AboutData',
          icon: <LuSquareDashedBottomCode width="20px" height="20px" color="inherit" className='text-lg' />,
          component: <AboutData />,
        },
      ]
    },
    {
      name: 'Transaction',
      layout: '/master',
      icon: <Icon as={BiTransferAlt} width="20px" height="20px" color="inherit" />,
      path: '/PurchaseBill',
      component: <PurchaseBill />,
      children: [
        {
          name: 'Purchase Bill',
          layout: '/master',
          icon: <Icon as={BiPurchaseTagAlt} width="20px" height="20px" color="inherit" />,
          path: '/PurchaseBill',
          component: <PurchaseBill />,
        },
        {
          name: 'Sales Invoice',
          layout: '/master',
          path: '/SalesInvoice',
          icon: <TbInvoice width="20px" height="20px" color="inherit" className='text-lg' />,
          component: <SalesInvoice />,
        },
        {
          name: 'Purchase Return',
          layout: '/master',
          path: '/PurchaseReturn',
          icon: <PiKeyReturn width="20px" height="20px" className='text-lg' color="inherit" />,
          component: <PurchaseReturn />,
        },
      ]
    },
    {
      name: 'Reports',
      layout: '/master',
      icon: <Icon as={LiaFileInvoiceSolid} width="20px" height="20px" color="inherit" />,
      path: '/PurchaseBill',
      component: <PurchaseBill />,
      children: [
        {
          name: 'Purchase Report',
          layout: '/master',
          path: '/PurchaseReport',
          icon: <BiPurchaseTagAlt width="20px" height="20px" className='text-lg' color="inherit" />,
          component: <PurchaseReport />,
        },
        {
          name: 'Sales Report',
          layout: '/master',
          path: '/SalesReport',
          icon: <LiaSortAmountUpSolid width="20px" height="20px" color="inherit" className='text-lg' />,
          component: <SalesReport />,
        },
        {
          name: 'Stock Report',
          layout: '/master',
          path: '/StockReport',
          icon: <AiOutlineStock width="20px" height="20px" color="inherit" className='text-lg' />,
          component: <StockReport />,
        },
        {
          name: 'Low Report',
          layout: '/master',
          path: '/LowReport',
          icon: <LiaSortAmountDownSolid width="20px" height="20px" color="inherit" className='text-lg' />,
          component: <LowReport />,
        },
        {
          name: 'Product Report',
          layout: '/master',
          path: '/ProductReport',
          icon: <AiOutlineProduct width="20px" height="20px" color="inherit" className='text-lg' />,
          component: <ProductReport />,
        },
        {
          name: 'GST Product Report',
          layout: '/master',
          path: '/GstProductReport',
          icon: <HiOutlineReceiptTax width="20px" height="20px" color="inherit" className='text-lg' />,
          component: <GstProductReport />,
        },
        {
          name: 'Expiry Date Report',
          layout: '/master',
          path: '/ExpiryDateReport',
          icon: <CgCalendarDates width="20px" height="20px" color="inherit" className='text-lg' />,
          component: <ExpDateReport />,
        },
        {
          name: 'Party Wise Report',
          layout: '/master',
          path: '/PartyWiseReport',
          icon: <CgCalendarDates width="20px" height="20px" color="inherit" className='text-lg' />,
          component: <MedicinePurchaseReport />,
        },
        {
          name: 'Product Batch Report',
          layout: '/master',
          path: '/ProductBatchReport',
          icon: <CgCalendarDates width="20px" height="20px" color="inherit" className='text-lg' />,
          component: < ProductBatchReport/>,
        }
      ]
    },
    {
      name: 'Admin User',
      layout: '/master',
      icon: <GrUserAdmin width="20px" height="20px" color="inherit" />,
      path: '/adminUser',
      component: <AdminUser />,
    },
  )
}

if (role == "Admin") {
  routes.push(
    {
      name: 'Master',
      layout: '/master',
      icon: <Icon as={MdBarChart} width="20px" height="20px" color="inherit" />,
      path: '/AccountMaster',
      component: <AccountMaster />,
      children: [
        {
          name: 'Account Master',
          layout: '/master',
          icon: <Icon as={AiOutlineIssuesClose} width="20px" height="20px" color="inherit" />,
          path: '/AccountMaster',
          component: <AccountMaster />,
        },
        {
          name: 'Batch Master',
          layout: '/master',
          path: '/BatchMaster',
          icon: <BiGroup width="20px" height="20px" color="inherit" className='text-lg' />,
          component: <BatchMaster />,
        },
        {
          name: 'Product Master',
          layout: '/master',
          path: '/ProductMaster',
          icon: <AiOutlineProduct width="20px" height="20px" color="inherit" className='text-lg' />,
          component: <ProductMaster />,
        },
        {
          name: 'Doctor Master',
          layout: '/master',
          path: '/DoctorMaster',
          icon: <FaUserDoctor width="20px" height="20px" color="inherit" />,
          component: <DoctorMaster />,
        },
        {
          name: 'Patient Master',
          layout: '/master',
          path: '/PatientMaster',
          icon: <TbUserCheck width="20px" height="20px" color="inherit" className='text-lg' />,
          component: <PatientMaster />,
        },
        {
          name: 'HSN Master',
          layout: '/master',
          path: '/HsnMaster',
          icon: <LuSquareDashedBottomCode width="20px" height="20px" color="inherit" className='text-lg' />,
          component: <HsnMaster />,
        },
        {
          name: 'About',
          layout: '/master',
          path: '/AboutData',
          icon: <LuSquareDashedBottomCode width="20px" height="20px" color="inherit" className='text-lg' />,
          component: <AboutData />,
        },
      ]
    },
    {
      name: 'Transaction',
      layout: '/master',
      icon: <Icon as={BiTransferAlt} width="20px" height="20px" color="inherit" />,
      path: '/PurchaseBill',
      component: <PurchaseBill />,
      children: [
        {
          name: 'Purchase Bill',
          layout: '/master',
          icon: <Icon as={BiPurchaseTagAlt} width="20px" height="20px" color="inherit" />,
          path: '/PurchaseBill',
          component: <PurchaseBill />,
        },
        {
          name: 'Sales Invoice',
          layout: '/master',
          path: '/SalesInvoice',
          icon: <TbInvoice width="20px" height="20px" color="inherit" className='text-lg' />,
          component: <SalesInvoice />,
        },
        {
          name: 'Purchase Return',
          layout: '/master',
          path: '/PurchaseReturn',
          icon: <PiKeyReturn width="20px" height="20px" className='text-lg' color="inherit" />,
          component: <PurchaseReturn />,
        },
      ]
    },
    {
      name: 'Reports',
      layout: '/master',
      icon: <Icon as={LiaFileInvoiceSolid} width="20px" height="20px" color="inherit" />,
      path: '/PurchaseBill',
      component: <PurchaseBill />,
      children: [
        {
          name: 'Purchase Report',
          layout: '/master',
          path: '/PurchaseReport',
          icon: <BiPurchaseTagAlt width="20px" height="20px" className='text-lg' color="inherit" />,
          component: <PurchaseReport />,
        },
        {
          name: 'Sales Report',
          layout: '/master',
          path: '/SalesReport',
          icon: <LiaSortAmountUpSolid width="20px" height="20px" color="inherit" className='text-lg' />,
          component: <SalesReport />,
        },
        {
          name: 'Stock Report',
          layout: '/master',
          path: '/StockReport',
          icon: <AiOutlineStock width="20px" height="20px" color="inherit" className='text-lg' />,
          component: <StockReport />,
        },
        {
          name: 'Low Report',
          layout: '/master',
          path: '/LowReport',
          icon: <LiaSortAmountDownSolid width="20px" height="20px" color="inherit" className='text-lg' />,
          component: <LowReport />,
        },
        {
          name: 'Product Report',
          layout: '/master',
          path: '/ProductReport',
          icon: <AiOutlineProduct width="20px" height="20px" color="inherit" className='text-lg' />,
          component: <ProductReport />,
        },
        {
          name: 'GST Product Report',
          layout: '/master',
          path: '/GstProductReport',
          icon: <HiOutlineReceiptTax width="20px" height="20px" color="inherit" className='text-lg' />,
          component: <GstProductReport />,
        },
        {
          name: 'Expiry Date Report',
          layout: '/master',
          path: '/ExpiryDateReport',
          icon: <CgCalendarDates width="20px" height="20px" color="inherit" className='text-lg' />,
          component: <ExpDateReport />,
        },
        {
          name: 'Party Wise Report',
          layout: '/master',
          path: '/PartyWiseReport',
          icon: <CgCalendarDates width="20px" height="20px" color="inherit" className='text-lg' />,
          component: <MedicinePurchaseReport />,
        },
      ]
    },
  )
}

export default routes;
